import { Box } from '@rebass/grid';
import { cursor } from 'utils/styles/customStyledSystemProps';
import styled from 'styled-components';
import {
	space,
	color,
	fontSize,
	width,
	height,
	gridGap,
	gridColumnGap,
	gridRowGap,
	gridColumn,
	gridRow,
	gridAutoFlow,
	gridAutoColumns,
	gridAutoRows,
	gridTemplateColumns,
	gridTemplateRows,
	gridTemplateAreas,
	gridArea,
	position,
	alignItems,
	justifyContent,
	textAlign,
	display,
	top,
	left,
	right,
	bottom
} from 'styled-system';

const BoxStyled = styled(Box)`
    ${space}
    ${color}
    ${width}
    ${height}
    ${fontSize}
    ${gridGap}
    ${position}
    ${gridColumnGap}
    ${gridRowGap}
    ${gridColumn}
    ${gridRow}
    ${gridAutoFlow}
    ${gridAutoColumns}
    ${gridAutoRows}
    ${gridTemplateColumns}
    ${gridTemplateRows}
    ${gridTemplateAreas}
    ${gridArea}
    ${alignItems}
    ${justifyContent}
	${textAlign}
	${display}
	${top}
	${left}
	${right}
	${bottom}
	${cursor}
`;

BoxStyled.propTypes = {
	...space.propTypes,
	...width.propTypes,
	...color.propTypes,
	...space.propTypes,
	...color.propTypes,
	...width.propTypes,
	...height.propTypes,
	...fontSize.propTypes,
	...gridGap.propTypes,
	...position.propTypes,
	...gridColumnGap.propTypes,
	...gridRowGap.propTypes,
	...gridColumn.propTypes,
	...gridRow.propTypes,
	...gridAutoFlow.propTypes,
	...gridAutoColumns.propTypes,
	...gridAutoRows.propTypes,
	...gridTemplateColumns.propTypes,
	...gridTemplateRows.propTypes,
	...gridTemplateAreas.propTypes,
	...gridArea.propTypes,
	...alignItems.propTypes,
	...justifyContent.propTypes,
	...textAlign.propTypes
};

export default BoxStyled;
